<div class="input-group">
  <input
    class="form-control py-2 border-right-0 border"
    id="search-input"
    [(ngModel)]="searchFilter"
    [placeholder]="placeholder"
    (keydown.enter)="onSubmit()"
    (ngModelChange)="onChange()"
    (keyupSearch)="onKeyup($event)" />
  <div
    class="input-group-append"
    *ngIf="searchOptions && searchOptions.length > 0">
    <app-evo-select>
      <ng-select
        [(ngModel)]="selectedOption"
        [items]="searchOptions"
        [clearable]="false"
        [appendTo]="'body'"
        bindLabel="name"
        bindValue="value">
      </ng-select>
    </app-evo-select>
  </div>
  <span class="input-group-append">
    <button
      class="btn btn-primary border-left-0 border"
      (click)="onSubmit()"
      type="button">
      <i class="fas fa-search"></i>
    </button>
  </span>
</div>
